import moment, { Moment } from 'moment';
import { timing } from '@morf/proto/timing/v1/timing_ts_proto';

export const formatTimestampToMoment = (
  timestamp: timing.v1.Timestamp
): Moment => moment.unix(timestamp.seconds.low);
